import { checkToken } from '@builddocs/data-management-auth'
import axios from 'axios'

import { checkKeycloakToken } from './auth/hooks/useKeycloakToken'

export const JournalServiceAPI = axios.create({
  baseURL: 'journal-service/api/v1/journals',
})

JournalServiceAPI.defaults.headers.common = {
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
  'Content-Type': 'application/json',
}

JournalServiceAPI.interceptors.request.use(async configuration => {
  await checkKeycloakToken(configuration)
  const config = await checkToken(configuration, true)

  return config
})
